import * as React from 'react';

export function SvgGoogleForms(props: any) {
  return (
    <svg
      {...props}
      viewBox="0 0 24 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_14_173)">
        <path
          d="M18.6875 22H5.3125C4.59062 22 4 21.3864 4 20.6364V3.36364C4 2.61364 4.59062 2 5.3125 2H15.1875L20 7V20.6364C20 21.3864 19.4094 22 18.6875 22Z"
          fill="#7248BC"
        />
        <path d="M15.1874 2L19.9999 7H15.1874V2Z" fill="#432382" />
        <path
          d="M10.25 16.928H16.25V15.7946H10.25V16.928ZM10.25 10.1275V11.2609H16.25V10.1275H10.25ZM8.88636 10.6942C8.88636 11.1632 8.51955 11.5443 8.06818 11.5443C7.61682 11.5443 7.25 11.1632 7.25 10.6942C7.25 10.2253 7.61682 9.84415 8.06818 9.84415C8.51955 9.84415 8.88636 10.2253 8.88636 10.6942ZM8.88636 13.5277C8.88636 13.9967 8.51955 14.3778 8.06818 14.3778C7.61682 14.3778 7.25 13.9967 7.25 13.5277C7.25 13.0588 7.61682 12.6777 8.06818 12.6777C8.51955 12.6777 8.88636 13.0588 8.88636 13.5277ZM8.88636 16.3613C8.88636 16.8302 8.51955 17.2113 8.06818 17.2113C7.61682 17.2113 7.25 16.8302 7.25 16.3613C7.25 15.8923 7.61682 15.5112 8.06818 15.5112C8.51955 15.5112 8.88636 15.8923 8.88636 16.3613ZM10.25 14.0944H16.25V12.961H10.25V14.0944Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_14_173">
          <rect
            width="16"
            height="20"
            fill="white"
            transform="translate(4 2)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}
